import {Injectable} from '@angular/core';
import {Dealer} from "../models/entities/dealer";

@Injectable({
  providedIn: 'root'
})
export class DealerService {

  dealers: Dealer[] = [];
}
